import api from '../services/api';
import {toastr} from 'react-redux-toastr';
import { 
    LOADING,
    LOGOUT,
} from './types';

export const changePassword = ({ passCurrent, passNew, passConfirm }) => {
    return async dispatch => {

        dispatch({ type: LOADING, payload: true });

        try {
            const response = await api.post(`/api/login/changePassword` , { passCurrent, passNew, passConfirm });
            const resposta = response.data;
            
            dispatch({ type: LOADING, payload: false });
            toastr.success(resposta.message);
            
        } catch (error) {
            dispatch({ type: LOADING, payload: false });

            if (error.response) {
                if(error.response.status==401) {
                    toastr.error('Error: '+error.response.status, error.response.data.message);

                    await localStorage.removeItem('token');
                    dispatch({ type: LOGOUT });
                }else{
                    toastr.error('Error: '+error.response.status, error.response.data.message);
                }
            }
        }
    }
}